import React from 'react';
import { number, object, string, oneOfType, bool, node } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { styled } from '@material-ui/core';

import Image from '../Image/Image';
import Typography from '../Typography/Typography';

const StatusTypography = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  color: 'grey',
}));

const Title = ({
  content,
  size = 35,
  src,
  icon,
  values,
  downSized = false,
  status,
  substatus,
  isPublicApiV4,
  modalName,
  style,
  alignItem = 'center',
}) => (
  <Grid name="title" container style={{ marginBottom: downSized ? '12px' : '17px' }} direction="column" alignItems="center">
    {!isPublicApiV4 && src && (
      <Grid item>
        <Image name={src} height={downSized ? 30 : size} width={downSized ? 30 : size} />
      </Grid>
    )}
    {icon && <Grid item>{icon}</Grid>}
    {content && (
      <Grid
        item
        container
        direction="row"
        justify={modalName === 'contextGarageNetwork' ? 'left' : alignItem}
        alignItems="baseline"
        style={{ marginTop: downSized ? '8px' : '16px' }}
      >
        <Typography
          content={content}
          values={values}
          variant="h6"
          style={{
            ...(downSized && { fontSize: '1.14rem' }),
            ...style,
          }}
        />
        {isPublicApiV4 && status && <StatusTypography content={status} />}
      </Grid>
    )}
    {isPublicApiV4 && substatus && <Typography content={substatus} style={{ color: '#CC010A' }} />}
  </Grid>
);

Title.propTypes = {
  content: oneOfType([number.isRequired, object.isRequired, string.isRequired]),
  size: number,
  src: string,
  values: object,
  downSized: bool,
  status: object,
  substatus: object,
  isPublicApiV4: bool,
  modalName: string,
  icon: node,
  style: object,
  alignItem: string,
};

export default Title;
